// tcData.js
export const tcData = [
  {
    tcNumber: "1035",
    dob: "17-08-2004",
    file: require("./assets/tc/ANSHI TIWARI 1035.jpeg"),
  },
  {
    tcNumber: "155",
    dob: "26-01-2010",
    file: require("./assets/tc/Anzar Azad 155.jpeg"),
  },
  {
    tcNumber: "2524",
    dob: "24-11-2011",
    file: require("./assets/tc/angel chandra 2524.jpeg"),
  },
  {
    tcNumber: "2593",
    dob: "13-10-2008",
    file: require("./assets/tc/Amit Verma 2593.jpg.jpeg"),
  },
  {
    tcNumber: "114",
    dob: "11-11-2003",
    file: require("./assets/tc/Amardeep 114.jpeg"),
  },
  {
    tcNumber: "975",
    dob: "27-09-2003",
    file: require("./assets/tc/Aman kumar 975.jpeg"),
  },
  {
    tcNumber: "1691",
    dob: "07-07-2006",
    file: require("./assets/tc/Aman Ansari.jpeg"),
  },
  {
    tcNumber: "1687",
    dob: "02-07-2005",
    file: require("./assets/tc/Akash verma 1687.jpeg"),
  },
  {
    tcNumber: "1071",
    dob: "16-11-2004",
    file: require("./assets/tc/Achal mishra 1071.jpeg"),
  },
  {
    tcNumber: "664",
    dob: "08-17-2006",
    file: require("./assets/tc/Abhishek singh 664.jpeg"),
  },
  {
    tcNumber: "2252",
    dob: "01-02-2017",
    file: require("./assets/tc/Abhinav shukla 2252.jpeg"),
  },
  {
    tcNumber: "278",
    dob: "04-09-2005",
    file: require("./assets/tc/Abdulla basir 278.jpeg"),
  },
  {
    tcNumber: "1871",
    dob: "26-10-2015",
    file: require("./assets/tc/Aarav shukla 1871.jpeg"),
  },
  {
    tcNumber: "2504",
    dob: "18-03-2016",
    file: require("./assets/tc/Aaradhay kumar Ojha 2504.jpeg"),
  },
  {
    tcNumber: "2633",
    dob: "20-02-2012",
    file: require("./assets/tc/2633 Shivangi shukla 1.jpg.jpeg"),
  },
  {
    tcNumber: "986",
    dob: "10-07-2005",
    file: require("./assets/tc/ARJUN TIWARI 986.jpeg"),
  },
  {
    tcNumber: "184",
    dob: "04-12-2006",
    file: require("./assets/tc/Arshad Kalam 184.jpeg"),
  },
  {
    tcNumber: "467",
    dob: "19-07-2008",
    file: require("./assets/tc/Chhavi verrma 467.jpeg"),
  },
  {
    tcNumber: "1483",
    dob: "23-07-2010",
    file: require("./assets/tc/Devid Raj 1483.jpeg"),
  },
  {
    tcNumber: "971",
    dob: "08-05-2006",
    file: require("./assets/tc/Dheeraj Verma 971.jpeg"),
  },
  {
    tcNumber: "518",
    dob: "15-08-2003",
    file: require("./assets/tc/Dilip 518.jpeg"),
  },
  {
    tcNumber: "2479",
    dob: "14-07-2008",
    file: require("./assets/tc/Dilip Kumar 2479.jpeg"),
  },
  {
    tcNumber: "141",
    dob: "29-01-2005",
    file: require("./assets/tc/Dipankar Roy.jpeg"),
  },
  {
    tcNumber: "1711",
    dob: "04-05-2003",
    file: require("./assets/tc/Faisal Khan 1711.jpeg"),
  },
  {
    tcNumber: "918",
    dob: "26-10-2005",
    file: require("./assets/tc/Mohd Ayan  918.jpeg"),
  },
  {
    tcNumber: "727",
    dob: "06-06-2004",
    file: require("./assets/tc/Mohd Saif 727.jpeg"),
  },
  {
    tcNumber: "805",
    dob: "24-09-2006",
    file: require("./assets/tc/Mohd Sameer 805.jpeg"),
  },
  {
    tcNumber: "215",
    dob: "24-07-2003",
    file: require("./assets/tc/mohd zai d 215.jpeg"),
  },
  {
    tcNumber: "512",
    dob: "20-04-2005",
    file: require("./assets/tc/Mohd. Asad 512.jpeg"),
  },
  {
    tcNumber: "662",
    dob: "29-07-2005",
    file: require("./assets/tc/Mohd. kaif 662.jpeg"),
  },
  {
    tcNumber: "1675",
    dob: "29-11-2006",
    file: require("./assets/tc/Falaq Qamar 1675.jpeg"),
  },
  {
    tcNumber: "968",
    dob: "01-08-2006",
    file: require("./assets/tc/Hasmuddin 968.jpeg"),
  },
  {
    tcNumber: "33",
    dob: "28-06-2007",
    file: require("./assets/tc/Himanshu raj 33.jpeg"),
  },
  {
    tcNumber: "1855",
    dob: "01-09-2012",
    file: require("./assets/tc/Jishan Ahmad 1855.jpeg"),
  },
  {
    tcNumber: "313",
    dob: "28-04-2005",
    file: require("./assets/tc/Juli Devi 313.jpeg"),
  },
  {
    tcNumber: "163",
    dob: "20-04-2010",
    file: require("./assets/tc/kartikkapoor 163.jpeg"),
  },
  {
    tcNumber: "1739",
    dob: "09-10-2008",
    file: require("./assets/tc/kashif qamar 1739.jpeg"),
  },
  {
    tcNumber: "956",
    dob: "20-07-2007",
    file: require("./assets/tc/Kuldeep kumar 956.jpeg"),
  },
  {
    tcNumber: "38",
    dob: "15-07-2004",
    file: require("./assets/tc/madhuram 38.jpeg"),
  },
  {
    tcNumber: "274",
    dob: "14-07-2005",
    file: require("./assets/tc/Manjeet singh 274.jpeg"),
  },
  {
    tcNumber: "662",
    dob: "29-07-2005",
    file: require("./assets/tc/Mohd. kaif 662.jpeg"),
  },
  {
    tcNumber: "918",
    dob: "26-10-2005",
    file: require("./assets/tc/Mohd Ayan  918.jpeg"),
  },
  {
    tcNumber: "573",
    dob: "23-06-2005",
    file: require("./assets/tc/mohd. Rehan 573.jpeg"),
  },
  {
    tcNumber: "1678",
    dob: "01-01-2007",
    file: require("./assets/tc/navjot singh 1678.jpeg"),
  },
  {
    tcNumber: "1090",
    dob: "08-06-2005",
    file: require("./assets/tc/Nikhil Gupta 1090.jpeg"),
  },
  {
    tcNumber: "38",
    dob: "05-07-2006",
    file: require("./assets/tc/nitin kamar 38.jpeg"),
  },
  {
    tcNumber: "880",
    dob: "05-12-2012",
    file: require("./assets/tc/nitya khanna 880.jpeg"),
  },
  {
    tcNumber: "157",
    dob: "02-03-2005",
    file: require("./assets/tc/Pawanpreet Kaur 157.jpeg"),
  },
  {
    tcNumber: "484",
    dob: "12-08-2006",
    file: require("./assets/tc/Priyanka verma 484.jpeg"),
  },
  {
    tcNumber: "1241",
    dob: "05-05-2003",
    file: require("./assets/tc/Priyanshu Mehrotra.jpeg"),
  },
  {
    tcNumber: "1696",
    dob: "18-10-2004",
    file: require("./assets/tc/VIVEK KUMAE 1696.jpeg"),
  },
  {
    name: "Qaynat Saniya",
    tcNumber: "199",
    dob: "16-05-2005",
    file: require("./assets/tc/qaynat saniya 199.jpeg"),
  },
  {
    name: "Samiya Khan",
    tcNumber: "690",
    dob: "07-07-2005",
    file: require("./assets/tc/Samiya khan 690.jpeg"),
  },
  {
    name: "Sandhya Raj",
    tcNumber: "1697",
    dob: "10-12-2004",
    file: require("./assets/tc/SANDHYA RAJ 1697.jpeg"),
  },
  {
    name: "Sarah Atiq",
    tcNumber: "204",
    dob: "21-01-2007",
    file: require("./assets/tc/Sara Atiq 204.jpeg"),
  },
  {
    name: "Satvinder Singh",
    tcNumber: "08",
    dob: "28-05-2005",
    file: require("./assets/tc/Satvinder singh 08.jpeg"),
  },
  {
    name: "Shaban Khan",
    tcNumber: "638",
    dob: "15-07-2005",
    file: require("./assets/tc/Shaban Khan 638.jpeg"),
  },
  {
    name: "Shahnawaz Ahmad",
    tcNumber: "637",
    dob: "08-07-2005",
    file: require("./assets/tc/shahnawaz 637.jpeg"),
  },
  {
    name: "Shivam Shukla",
    tcNumber: "1685",
    dob: "01-10-2006",
    file: require("./assets/tc/Shivam Shukla 1685.jpeg"),
  },
  {
    name: "Shivam Yadav",
    tcNumber: "357",
    dob: "08-10-2006",
    file: require("./assets/tc/Shivam Yadav 357.jpeg"),
  },

  // New records from ZIP folder

  {
    name: "Akash Bharti",
    tcNumber: "1388",
    dob: "09-08-2012",
    file: require("./assets/tc/1388 Akash Bharti.jpg"),
  },
  {
    name: "Abhimanyu Patel",
    tcNumber: "1623",
    dob: "05-10-2016",
    file: require("./assets/tc/1623 Abhimanyu Patel.jpg"),
  },
  {
    name: "Mohd Faiz",
    tcNumber: "1831",
    dob: "20-04-2008",
    file: require("./assets/tc/1831 Mohd Faiz.jpg"),
  },
  {
    name: "Anupam Bharti",
    tcNumber: "1845",
    dob: "09-03-2010",
    file: require("./assets/tc/1845 Anupam Bharti.jpg"),
  },
  {
    name: "Gyan Tiwari",
    tcNumber: "1872",
    dob: "07-09-2018",
    file: require("./assets/tc/1872 Gyan Tiwari.jpg"),
  },
  {
    name: "Nishant Verma",
    tcNumber: "1878",
    dob: "25-05-2012",
    file: require("./assets/tc/1878 Nishant Verma.jpg"),
  },
  {
    name: "Uwesh Khan",
    tcNumber: "1901",
    dob: "23-02-2012",
    file: require("./assets/tc/1901 Uwesh Khan.jpg"),
  },
  {
    name: "Mohd. Maaz Ansari",
    tcNumber: "1995",
    dob: "09-05-2017",
    file: require("./assets/tc/1995 Mohd. Maaz Ansari.jpg"),
  },
  {
    name: "Ankit Jaiswal",
    tcNumber: "2208",
    dob: "16-08-2009",
    file: require("./assets/tc/2208 Ankit Jaiswal.jpg"),
  },
  {
    name: "Shivank Tripathi",
    tcNumber: "2573",
    dob: "05-02-2019",
    file: require("./assets/tc/2573 Shivank Tripathi.jpg"),
  },
  {
    name: "Parvesh",
    tcNumber: "2619",
    dob: "14-07-2017",
    file: require("./assets/tc/2619 Parvesh.jpg"),
  },
  {
    name: "Mo Ahad",
    tcNumber: "2830",
    dob: "09-03-2016",
    file: require("./assets/tc/2830 Mo Ahad.jpg"),
  },
  {
    name: "Varun Singh",
    tcNumber: "2945",
    dob: "23-12-2018",
    file: require("./assets/tc/2945 Varun Singh.jpg"),
  },
  {
    name: "Dhanush Singh",
    tcNumber: "2946",
    dob: "02-10-2018",
    file: require("./assets/tc/2946 Dhanush singh.jpg"),
  },
  {
    name: "Nitya Verma",
    tcNumber: "3078",
    dob: "12-02-2016",
    file: require("./assets/tc/3078 Nitya Verma.jpg"),
  },
  {
    name: "Priyansh Verma",
    tcNumber: "3115",
    dob: "19-04-2020",
    file: require("./assets/tc/3115 Priyansh Verma.jpg"),
  },
  {
    name: "Safoora",
    tcNumber: "3140",
    dob: "05-05-2015",
    file: require("./assets/tc/3140 Safoora.jpg"),
  },
  {
    name: "Aradhya Verma",
    tcNumber: "3317",
    dob: "01-01-2017",
    file: require("./assets/tc/3317 Aradhya Verma.jpg"),
  },
  {
    name: "Humera Naaz",
    tcNumber: "3370",
    dob: "25-02-2019",
    file: require("./assets/tc/3370 Humera Naaz.jpg"),
  },
  {
    name: "Chandra Mohan",
    tcNumber: "3439",
    dob: "06-01-2017",
    file: require("./assets/tc/3439 Chandra Mohan.jpg"),
  },
  {
    name: "Samar Rawat",
    tcNumber: "486",
    dob: "20-02-2009",
    file: require("./assets/tc/486 Samar Rawat.jpg"),
  },
  {
    name: "Nitin Verma",
    tcNumber: "746",
    dob: "24-06-2009",
    file: require("./assets/tc/746 Nitin Verma.jpg"),
  },
  {
    name: "Anam",
    tcNumber: "3025",
    dob: "14-10-2013",
    file: require("./assets/tc/anam 3025.jpg"),
  },
  {
    name: "Anayza Javed",
    tcNumber: "2934",
    dob: "04-09-2020",
    file: require("./assets/tc/Anayza Javed 2934.jpg"),
  },
  {
    name: "Anshdeep Singh",
    tcNumber: "2666",
    dob: "03-02-2012",
    file: require("./assets/tc/Anshdeep Singh 2666.jpg.jpeg"),
  },
  {
    name: "Anushka Shukla",
    tcNumber: "751",
    dob: "20-03-2012",
    file: require("./assets/tc/Anushka Shukla 751.jpg.jpeg"),
  },
  {
    name: "Avika",
    tcNumber: "1650",
    dob: "01-03-2012",
    file: require("./assets/tc/avika 1650.jpg.jpeg"),
  },
  {
    name: "Avinoor Singh",
    tcNumber: "528",
    dob: "13-07-2012",
    file: require("./assets/tc/Avinoor Singh 528.jpg.jpeg"),
  },
  {
    name: "Ayush Rahi",
    tcNumber: "1859",
    dob: "01-06-2012",
    file: require("./assets/tc/Ayush Rahi 1859.jpg.jpeg"),
  },
  {
    name: "Eram Fatima",
    tcNumber: "2884",
    dob: "28-03-2013",
    file: require("./assets/tc/Eram Fatima 2884.jpg.jpeg"),
  },
  {
    name: "Gurmehar Singh",
    tcNumber: "26",
    dob: "17-09-2008",
    file: require("./assets/tc/Gurmehar singh 26.jpg"),
  },
  {
    name: "Hanzala",
    tcNumber: "921",
    dob: "25-01-2008",
    file: require("./assets/tc/hanzala 921.jpg.jpeg"),
  },
  {
    name: "Ilma Parveen",
    tcNumber: "216",
    dob: "17-09-2008",
    file: require("./assets/tc/Ilma Parveen 216.jpg.jpeg"),
  },
  {
    name: "Kavya Tripathi",
    tcNumber: "2573",
    dob: "15-11-2018",
    file: require("./assets/tc/Kavya Tripathi 2573.jpg"),
  },
  {
    name: "Khushmeet Kaur",
    tcNumber: "605",
    dob: "12-08-2008",
    file: require("./assets/tc/Khushmeet Kaur 605.jpg.jpeg"),
  },
  {
    name: "Mohd. Ariz",
    tcNumber: "1890",
    dob: "18-10-2016",
    file: require("./assets/tc/Mohd. Ariz 1890.jpg"),
  },
  {
    name: "Mohd. Saad",
    tcNumber: "2580",
    dob: "02-07-2018",
    file: require("./assets/tc/Mohd. Saad 2580.jpg"),
  },
  {
    name: "Monu Yadav",
    tcNumber: "2241",
    dob: "15-01-2008",
    file: require("./assets/tc/monu yadav 2241.jpg.jpeg"),
  },
  {
    name: "Parth",
    tcNumber: "431",
    dob: "07-06-2011",
    file: require("./assets/tc/parth 431.jpg.jpeg"),
  },
  {
    name: "Rishalat Ali",
    tcNumber: "1889",
    dob: "03-08-2013",
    file: require("./assets/tc/Rishalat Ali 1889.jpg"),
  },
  {
    name: "Sanskriti Yadav",
    tcNumber: "3308",
    dob: "03-01-2020",
    file: require("./assets/tc/Sanskriti Yadav 3308.jpg.jpeg"),
  },
  {
    name: "Saranpreet Singh",
    tcNumber: "3303",
    dob: "01-09-2019",
    file: require("./assets/tc/Saranpreet singh 3303.jpg.jpeg"),
  },
  {
    name: "Sarita",
    tcNumber: "2695",
    dob: "01-11-2008",
    file: require("./assets/tc/Sarita 2695.jpg"),
  },
  {
    name: "Sarthak Shukla",
    tcNumber: "722",
    dob: "15-07-2010",
    file: require("./assets/tc/Sarthak Shukla 722.jpg"),
  },
  {
    name: "Saurya Shukla",
    tcNumber: "2151",
    dob: "01-04-2017",
    file: require("./assets/tc/Saurya Shukla 2151.jpg.jpeg"),
  },
  {
    name: "Shiva",
    tcNumber: "2744",
    dob: "10-03-2010",
    file: require("./assets/tc/Shiva 2744.jpg.jpeg"),
  },
  {
    name: "Taranpreet Singh",
    tcNumber: "3304",
    dob: "09-05-2018",
    file: require("./assets/tc/Taranpreet singh 3304.jpg.jpeg"),
  },
  {
    name: "Vishal Verma",
    tcNumber: "2763",
    dob: "01-01-2011",
    file: require("./assets/tc/Vishal Verma 2763.jpg"),
  },


  {
    name: "Anupam Bharti",
    tcNumber: "1345",
    dob: "30-03-2010",
    file: require("./assets/tc/Anupam Bharti 1345.jpeg"),
  },

    {
    name: "Gyan Tiwari",
    tcNumber: "1872,",
    dob: "07-09-2011",
    file: require("./assets/tc/Gyan Tiwari 1872.jpeg"),
  },

      {
    name: "Varun singh",
    tcNumber: "2945,",
    dob: "23-12-2011",
    file: require("./assets/tc/Varun singh 2945.jpeg"),
  },
  

  {
    name: "Shivank Tripathi",
    tcNumber: "2573,",
    dob: "05-08-2019",
    file: require("./assets/tc/Shivank Tripathi 2573.jpeg"),
  },

    {
    name: "Kavya Tripathi",
    tcNumber: "2572,",
    dob: "15-11-2018",
    file: require("./assets/tc/kavya ripathi 2572.jpeg"),
  },

];